<div>
    @for (item of component.items; track $index; let isFirst = $first) {
    <href class="block link"
          [ngClass]="[item.text_style || '']"
          [class.m-t-2]="!isFirst"
          [link]="item.link">
        <span *iCms="'text' of item"></span>
    </href>
    }
</div>